import React from "react";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { IconContainer, TimelineItemContainer } from "./GameTimeline.styles";
import {
    ShorterTimelineItem,
    TimelineConnector,
    TimelineContent,
    TimelineContentContainer,
    TimelineItemElement,
    TimelineItemRightColumn,
    TimelineOppositeContent,
    TimelineSubline,
} from "./TimelineItem.styles";
import { TimelineItemTitle } from "./Factory/GameTimelineFactory.styles";
import { GamePlayerIcon } from "./GamePlayerIcon";

export function TimelineItem({
    headline,
    icon,
    playerData,
    subline,
    title,
    shorterItem = false,
    opposite = false,
}: {
    headline: string;
    icon: React.JSX.Element;
    playerData:
        | {
              id: string | undefined;
              imageUrl: string | undefined;
              name: string | undefined;
          }
        | undefined;
    title: string;
    opposite?: boolean;
    shorterItem?: boolean;
    subline?: string;
    trackSizeChange?: boolean;
}) {
    const TimelineElement = shorterItem
        ? ShorterTimelineItem
        : TimelineItemElement;

    const playerPresent = playerData?.id;

    return (
        <TimelineElement>
            <TimelineOppositeContent>
                {opposite && (
                    <TimelineContentContainer>
                        {playerPresent && (
                            <GamePlayerIcon playerData={playerData} />
                        )}
                        <TimelineItemRightColumn>
                            <TimelineItemContainer>
                                <IconContainer>{icon}</IconContainer>{" "}
                                <TimelineItemTitle>
                                    {headline}
                                </TimelineItemTitle>
                            </TimelineItemContainer>
                            {subline && (
                                <TimelineSubline>{subline}</TimelineSubline>
                            )}
                        </TimelineItemRightColumn>
                    </TimelineContentContainer>
                )}
            </TimelineOppositeContent>
            <TimelineSeparator>
                <TimelineConnector />
                <TimelineItemTitle>{title}</TimelineItemTitle>
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
                {!opposite && (
                    <TimelineContentContainer>
                        {playerPresent && (
                            <GamePlayerIcon playerData={playerData} />
                        )}
                        <TimelineItemRightColumn>
                            <TimelineItemContainer>
                                <IconContainer>{icon}</IconContainer>{" "}
                                <TimelineItemTitle>
                                    {headline}
                                </TimelineItemTitle>
                            </TimelineItemContainer>
                            {subline && (
                                <TimelineSubline>{subline}</TimelineSubline>
                            )}
                        </TimelineItemRightColumn>
                    </TimelineContentContainer>
                )}
            </TimelineContent>
        </TimelineElement>
    );
}
